"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walkMeSessionCookie = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
const walkMeSessionCookie = exports.walkMeSessionCookie = 'icis.walkMe';
class WalkMeComponent extends React.Component {
  constructor() {
    super(...arguments);
    this.checkAndAdd = () => {
      this.loaded = true;
      this.populateUserInfo();
      this.loadWalkMeScript();
    };
    this.loadWalkMeScript = () => {
      const isWalkeMeScriptInDom = document.getElementById("walkme-inline-script-file");
      if (isWalkeMeScriptInDom) {
        return;
      }
      const {
        url = ''
      } = this.props.appConfig.walkMe;
      const walkMe = document.createElement('script');
      walkMe.type = 'text/javascript';
      walkMe.async = true;
      walkMe.src = url;
      walkMe.id = 'walkme-inline-script-file';
      const s = document.getElementsByTagName('script')[0];
      /* istanbul ignore else */
      if (s && s.parentNode) {
        s.parentNode.insertBefore(walkMe, s);
      }
      window._walkmeConfig = {
        smartLoad: true
      };
    };
  }
  componentDidMount() {
    const userId = this.getUserId();
    if (!userId) {
      this.timeOut = setTimeout(this.checkAndAdd, this.props.appConfig.walkMe.waitTime);
    } else {
      this.checkAndAdd();
    }
  }
  componentDidUpdate() {
    const userId = this.getUserId();

    /* istanbul ignore if */
    if (userId && !this.loaded) {
      this.clearTimeOut();
      this.checkAndAdd();
    }
  }
  componentWillUnmount() {
    this.clearTimeOut();
  }
  clearTimeOut() {
    clearTimeout(this.timeOut);
  }
  getUserId() {
    return (0, _get.default)(this.props, 'data.user.userId');
  }
  populateUserInfo() {
    const {
      user: {
        userId,
        type,
        entitlements = [],
        isInternal,
        isNewHomeUser
      } = {},
      preferences: {
        userLanguage
      } = {}
    } = this.props.data;
    const hasBetaFeature = feature => entitlements.some(el => el.toLowerCase() === feature.toLowerCase());
    const dataEntitlements = entitlements.filter(entitlement => {
      const lowercaseEntitlement = entitlement.toLowerCase();
      return !(lowercaseEntitlement.startsWith('wd-') || lowercaseEntitlement.startsWith('chan-'));
    });
    const isCreditsUser = hasBetaFeature('ICIS Pricing Online Credits');
    const isMixedCreditsUser = isCreditsUser && dataEntitlements.length > 1;
    window.wmGen = {
      vug: userId,
      hasGenesisBeta: hasBetaFeature('genesis-beta'),
      hasHubBeta: hasBetaFeature('hub-beta'),
      userType: type,
      isInternal,
      entitlements: entitlements.reduce((obj, item) => {
        obj[item] = true;
        return obj;
      }, {}),
      isNewHomeUser,
      isCreditsUser,
      isMixedCreditsUser
    };
    window.walkme_get_language = function () {
      if (userLanguage.toLowerCase().indexOf('zh') !== -1) return 'ZH';
      return '';
    };
  }
  render() {
    return null;
  }
}
exports.default = WalkMeComponent;